import { render } from "./BranchView.vue?vue&type=template&id=68a6674c&scoped=true&ts=true"
import script from "./BranchView.vue?vue&type=script&lang=ts"
export * from "./BranchView.vue?vue&type=script&lang=ts"

import "./BranchView.vue?vue&type=style&index=0&id=68a6674c&scoped=true&lang=scss"

import exportComponent from "C:\\vue项目\\baiduobang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a6674c"]])

export default __exports__